import axios from 'axios';
import { clearCompanyData } from '../utils/clearCompanyData';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const backendApi = axios.create({
  baseURL: API_URL,
});

backendApi.interceptors.request.use(
  (request) => {
    const accessToken = localStorage.getItem('accessToken')
      ? JSON.parse(localStorage.getItem('accessToken') || 'null')
      : null;

    if (accessToken && request.headers) {
      request.headers.Authorization = `JWT ${accessToken}`;
    }

    return request;
  },
  (error) => {
    return Promise.reject(error);
  },
);

backendApi.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response?.status === 401) {
      // Token expired, redirect to login
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('userEmail');
      clearCompanyData();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  },
);

export default backendApi;
